const config = {
  FLASH_INSTALL: {
    ERROR_TEXT: 'The latest version of Flash must be enabled to view this video. Once enabled, click "refresh" in your browser to view this video.',
    VERSION: {
      MAJOR: '9',
      MINOR: '0',
      REVISION: '115',
      RAW: '9.0.115'
    }
  },
  RESOURCE_URL: {
    JWPLAYER_JS: 'https://www.autotrader.com/resources/js/external/jwplayer/jwplayer.js',
    JWPLAYER_SWF: 'https://www.autotrader.com/resources/js/external/jwplayer/jwplayer.flash.swf',
    JWPLAYER_PLUGINS: 'https://www.autotrader.com/resources/swf/components/jwplayer/ErrorPlugin.swf',
    SISTER_PLAYER_IFRAMESRC: 'http://3df.pod0.sister.tv/3df/3df-dist-2.0/player.php'
  },
  SISTER_VIDEO: {
    CONTAINER_ID: 'SiSTeR',
    PUBLISHER_PROFILE: 'ATC',
    PUBID: '3DF',
    ASPECT_RATIO: '16:9'
  },
  LIQUIDUS_VIDEO: {
    LIQUIDUS_JS: 'https://vl.aqueousdt.com/CDN/Script/Main.js'
  },
  VIDEO_FACTORIES: {
    default: 'jw',
    SISTER: 'sister'
  }
};
export default config;